<template>
  <SvgIcon
    v-if="iconInfo.isSvg"
    v-bind="$attrs"
    :name="iconInfo.svgName"
    :class="['anticon', $attrs.class]"
    :size="size"
    :spin="spin"
  />
  <i
    v-else
    v-bind="$attrs"
    :class="[iconInfo.family, iconInfo.className, $attrs.class, { 'no-icon': !props.icon }]"
    :style="wrapStyle"
  ></i>
</template>

<script lang="ts" setup>
  import { computed, CSSProperties } from 'vue';
  import { adaptiveSize } from '@mts/utils';
  import { PADMode } from '@mts/utils/env';
  import { type IconPrefix, SvgIcon } from '..';

  /** 图标：支持svg与iconfont形式 */
  defineOptions({ name: 'MIcon' });

  const props = withDefaults(
    defineProps<{
      prefix?: IconPrefix | '';
      icon?: string;
      color?: string;
      size?: number | string;
      spin?: boolean;
    }>(),
    { prefix: PADMode ? 'pad' : 'pc', icon: '', size: 16 },
  );

  const SVG_END_WITH_FLAG = '|svg';
  const ICON_PREFIX = 'icon-';

  const iconInfo = computed(() => {
    const { icon } = props;
    const prefix = icon.includes(ICON_PREFIX) ? icon.split('-')[1] : props.prefix;
    const family = `mts-icon-${prefix}`;

    if (!icon) return { isSvg: false, family, className: '', svgName: '' };

    if (icon.endsWith(SVG_END_WITH_FLAG)) {
      const baseName = icon.replace(SVG_END_WITH_FLAG, '').replace(`${ICON_PREFIX}${prefix}-`, '');
      const svgName = prefix ? `${ICON_PREFIX}${prefix}-${baseName}` : baseName;
      return { isSvg: true, family, className: '', svgName };
    }

    const fullPrefix = `${ICON_PREFIX}${prefix}-`;
    const className = fullPrefix + icon.replace(fullPrefix, '');
    return { isSvg: false, family, className, svgName: '' };
  });

  const wrapStyle = computed((): CSSProperties => {
    const sizeValue = typeof props.size === 'string' ? parseFloat(props.size) : props.size;
    const fontSize = adaptiveSize(sizeValue) + 'px';

    const style: CSSProperties = { fontSize };
    if (props.color) {
      style.color = props.color;
    }
    return style;
  });
</script>

<style>
  .no-icon {
    display: block;
    min-width: 1em;
    min-height: 1em;
    border-radius: 100%;
    background-color: #5551;
  }
</style>
